module.exports = __webpack_public_path__ + "4f64ef7279fc5341906729876df4a6ae.jpg";